<template>
  <v-card>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon v-if="newBlkAddlDesc">mdi-plus</v-icon>
      <v-icon v-else-if="queryBlkAddlDesc">mdi-magnify</v-icon>
      <v-icon v-else>mdi-pencil</v-icon>
      <v-toolbar-title v-if="newBlkAddlDesc">Create Additional Block</v-toolbar-title>
      <v-toolbar-title v-else-if="queryBlkAddlDesc">Query Additional Block</v-toolbar-title>
      <v-toolbar-title v-else>Edit Additional Block</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <message :messages="messages"></message>
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{ labels.accmType }}</v-subheader>
            <div class="queryValue">{{ getDesc(blkAddlDescForm.accmType) }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.blkGrp }}</v-subheader>
            <div class="queryValue">{{ blkAddlDescForm.blkGrp + ' - ' + blkAddlDescForm.blkGrpDescS }}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.blksGrp1 }}</v-subheader>
            <div class="queryValue" v-if="blkAddlDescForm.blksGrp1">{{ blkAddlDescForm.blksGrp1 + ' - ' + blkAddlDescForm.blksGrp1DescS }}</div>
            <div class="quearyValue">-</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.blksGrp2 }}</v-subheader>
            <div class="queryValue" v-if="blkAddlDescForm.blksGrp2">{{ blkAddlDescForm.blksGrp2 + ' - ' + blkAddlDescForm.blksGrp2DescS }}</div>
            <div class="quearyValue">-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.blk }}</v-subheader>
            <div class="queryValue">{{ blkAddlDescForm.blk + ' - ' + blkAddlDescForm.blkDesc }}</div>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs4 v-if="!queryBlkAddlDesc">
            <v-text-field
              v-model="blkAddlDescForm.seqNo"
              :label="labels.seqNo"
              :error-messages="errors.collect('seqNo')"
              data-vv-name="seqNo"
              :data-vv-as="labels.seqNo"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs4 v-else>
            <v-subheader class="queryLabel">{{ labels.seqNo }}</v-subheader>
            <div class="queryValue">{{ blkAddlDescForm.seqNo }}</div>
          </v-flex>
          <v-flex xs8 v-if="!queryBlkAddlDesc">
            <v-text-field
              v-model="blkAddlDescForm.blkAddlDesc"
              :label="labels.blkAddlDesc"
              :error-messages="errors.collect('blkAddlDesc')"
              data-vv-name="blkAddlDesc"
              :data-vv-as="labels.blkAddlDesc"
            ></v-text-field>
          </v-flex>
          <v-flex xs8 v-else>
            <v-subheader class="queryLabel">{{ labels.blkAddlDesc }}</v-subheader>
            <div class="queryValue">{{ blkAddlDescForm.blkAddlDesc }}</div>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
            <div class="queryValue">{{ blkAddlDescForm.createdName }}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDate(blkAddlDescForm.createdDate) }}</div>
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="!newBlkAddlDesc">
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
            <div class="queryValue">{{ blkAddlDescForm.modifiedName }}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDate(blkAddlDescForm.modifiedDate) }}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click.native="close()">Cancel</v-btn>
      <v-btn color="primary" text v-if="!queryBlkAddlDesc" @click.native="doSave">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'

export default {
  props: {
    blkAddlDescForm: Object,
    seqNo: Number,
    mode: String
  },
  data() {
    return {
      title: '',
      labels: {
        accmType: 'Accumulation Type',
        blkGrp: 'Block Group',
        blksGrp1: 'Block Sub Group 1',
        blksGrp2: 'Block Sub Group 2',
        blk: 'Block',
        seqNo: 'Sequence No',
        blkAddlDesc: 'Description',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      newBlkAddlDesc: false,
      queryBlkAddlDesc: false,
      accmTypeList: [],
      submitting: false
    }
  },
  computed: {
    menu() {
      return this.$store.state.blkParam.menu
    }
  },
  watch: {
    mode: function (value) {
      this.doInit()
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      if (this.mode === 'new') {
        this.doInitForm()
        this.blkAddlDescForm.seqNo = this.seqNo
        this.newBlkAddlDesc = true
        this.queryBlkAddlDesc = false
        this.title = 'New Block Group'
      } else {
        this.setValue()
        if (this.mode === 'edit') {
          this.newBlkAddlDesc = false
          this.queryBlkAddlDesc = false
          this.title = 'Review Block Group'
        } else {
          this.newBlkAddlDesc = false
          this.queryBlkAddlDesc = true
          this.title = 'Query Block Group'
        }
      }
    },
    getDesc(id) {
      for (var i in this.accmTypeList) {
        if (this.accmTypeList[i].value === id) {
          if (this.accmTypeList[i].label !== null) {
            return this.accmTypeList[i].label
          } else {
            return ''
          }
        }
      }
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doInitForm() {
      this.resetMessages()
      this.blkAddlDescForm.blkAddlDesc = null
      this.blkAddlDescForm.createdName = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.blkAddlDescForm.createdDate = new Date()
      this.setValue()
    },
    async getAccmTypeList() {
      const apiURI = this.menu.getAccmTypeList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.accmTypeList = []
        if (data) {
          data.map((accmType) => {
            const convertList = {
              label: accmType.accmType + ' - ' + accmType.accmTypeDesc,
              value: accmType.accmType,
              blkGrpLblS: accmType.blkGrpLblS,
              blkSgrp1LblS: accmType.blkSgrp1LblS,
              blkSgrp2LblS: accmType.blkSgrp2LblS,
              blkLblS: accmType.blkLblS
            }
            this.accmTypeList.push(convertList)
          })
        }
      }
    },
    setValue() {
      for (var i in this.accmTypeList) {
        if (this.accmTypeList[i].value === this.blkAddlDescForm.accmType) {
          this.labels.blkGrp = this.accmTypeList[i].blkGrpLblS
          if (this.accmTypeList[i].blkSgrp1LblS) {
            this.labels.blksGrp1 = this.accmTypeList[i].blkSgrp1LblS
          }
          if (this.accmTypeList[i].blkSgrp2LblS) {
            this.labels.blksGrp2 = this.accmTypeList[i].blkSgrp2LblS
          }
          if (this.accmTypeList[i].blkLblS) {
            this.labels.blk = this.accmTypeList[i].blkLblS
          }
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newBlkAddlDesc) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createBlkAddlDesc
      if (apiURI) {
        this.submitting = true
        try {
          this.blkAddlDescForm.blksGrp1 = this.blkAddlDescForm.blksGrp1 || ''
          this.blkAddlDescForm.blksGrp2 = this.blkAddlDescForm.blksGrp2 || ''
          const result = await this.$http.post(apiURI, this.blkAddlDescForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.blkAddlDescForm.seqNo += 1
            this.close()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateBlkAddlDesc
      if (apiURI) {
        this.submitting = true
        try {
          this.blkAddlDescForm.blksGrp1 = this.blkAddlDescForm.blksGrp1 || ''
          this.blkAddlDescForm.blksGrp2 = this.blkAddlDescForm.blksGrp2 || ''
          const result = await this.$http.put(apiURI, this.blkAddlDescForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.close()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    close() {
      this.doInitForm()
      this.$emit('close')
    }
  },
  async created() {
    await this.getAccmTypeList()
    this.doInit()
  },
  mixins: [MessageMixin]
}
</script>
